import React, { useState, useEffect } from "react";
import "../Home/Initial.css";

const Initial = () => {
  const fullText = "Beem-vindo(a)! Aqui seu dizer encontra ouvidos atentos";
  const [displayedText,
    setDisplayedText] = useState("");

  useEffect(() => {
    let currentTextIndex = 0;

    const typingInterval = setInterval(() => {
      if (currentTextIndex < fullText.length -1) {
        setDisplayedText(prevText => prevText + fullText[currentTextIndex]);
        currentTextIndex++;

      } else {
        clearInterval(typingInterval);
      }
    }, 100);
    return () => clearInterval(typingInterval);
  }, []);

  return (
    <div id="initial" className="">
      <div className="initial-container">
        <div className="initial-title">
          <h1 className="title">LAYNA TAMBUCCI</h1>
          <span className="initial-message">Psicanalista | Psicóloga CRP 06/226240</span>
        </div>
        <div className="second-message-wrapper">
          <span className="second-message typewriter-text">
            {displayedText}
            {<span className="cursor">|</span>}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Initial;
